// extracted by mini-css-extract-plugin
export default {"sidebarContainer":"bq_fG","poster":"bq_fT","posterTitle":"bq_fV","sidebarButtonWrapper":"bq_fY","sidebarButton":"bq_fZ"};